import React from 'react'
import '../../styles/Diagnostic/DiagnosticTermite.css'
import { Fade } from 'react-awesome-reveal'
import diagnosticTermiteSection1 from '../../assets/diagnostic/diagnostic-termite-section1.jpg'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticTermiteSection2 from '../../assets/diagnostic/diagnostic-termite-section2.jpg'
import AccordionText from '../Utils/AccordionText'
import diagnosticTermiteSection3 from '../../assets/diagnostic/diagnostic-termite-section3.jpg'
import diagnosticTermiteSection4 from '../../assets/diagnostic/diagnostic-termite-section4.jpg'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticTermite() {

    const section2AccordionData = [
        {
            title: "Protection du patrimoine immobilier",
            text: "Les termites sont capables de causer des dommages importants aux structures en bois d’un bâtiment, compromettant ainsi sa solidité et sa sécurité. Un diagnostic permet d’identifier à temps la présence de ces nuisibles pour prendre les mesures adéquates."
        }, {
            title: "Obligation légale pour la vente",
            text: "Dans les zones définies par arrêté préfectoral comme étant à risque, le diagnostic termites est obligatoire pour toute vente de bien immobilier. Le vendeur doit fournir ce diagnostic à l’acheteur, qui doit dater de moins de six mois au moment de la vente"
        }
    ]

    const section3AccordionData = [
        {
            title: "Structures en bois",
            text: "Charpentes, poutres, planchers, et autres éléments porteurs ou non porteurs en bois."
        }, {
            title: "Revêtements en bois",
            text: "Parquets, lambris, plinthes et boiseries."
        }, {
            title: "Isolants contenant de la cellulose ",
            text: "Certains types d’isolants peuvent être attractifs pour les termites si ces derniers parviennent à y accéder."
        }, {
            title: "Mobilier en bois",
            text: "Bien que le diagnostic se concentre sur la structure du bâtiment, le mobilier en bois peut également être infesté et nécessiter une inspection."
        }
    ]

    const section4Accordion1Data = [
        {
            title: "Expertise professionnelle",
            text: "Le diagnostic doit être effectué par un diagnostiqueur professionnel certifié, qui utilisera des techniques spécifiques pour inspecter le bâtiment à la recherche de termites et de signes d’infestation, " +
                "tels que des galeries dans le bois, de la sciure ou des déjections."
        }, {
            title: "Méthodologie",
            text: "L’expert procède à un examen visuel approfondi des éléments accessibles du bâtiment, en se concentrant particulièrement sur les structures en bois. L’utilisation d’outils spécifiques peut être nécessaire pour " +
                "évaluer l’étendue de l’infestation ou pour détecter la présence de termites dans des zones difficilement accessibles."
        }, {
            title: "Rapport de diagnostic",
            text: "À l’issue de l’inspection, le diagnostiqueur remet un rapport détaillant les observations, l’existence ou non d’une infestation et, le cas échéant, les recommandations pour traiter le problème. Ce document " +
                "est essentiel pour la transaction immobilière et peut influencer les décisions de l’acheteur."
        }
    ]

    const section4Accordion2Data = [
        {
            title: "Zones non infestées",
            text: "Le diagnostic termites est obligatoire uniquement dans les zones géographiques déclarées à risque par un arrêté préfectoral. Si le bien immobilier se situe hors de ces zones, le diagnostic n’est pas requis."
        }, {
            title: "Validité du diagnostic",
            text: "Si un diagnostic termites a été réalisé dans les six mois précédant la vente et que le bien se situe dans une zone à risque, un nouveau diagnostic n’est pas nécessaire pour une nouvelle transaction immobilière dans ce délai. Néanmoins, étant donné la rapidité avec laquelle une infestation peut se développer, il est toujours conseillé de vérifier l’actualité du diagnostic."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Termites - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Termites sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Termites - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Termites sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-termite" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-termite" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticTermite'>
                    <div id='header'>
                        <div id='diagnosticTermiteHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic Termites</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticTermiteSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticTermiteSection1Left'>
                                    <h1 className='sectionTitle'>En quoi consiste un diagnostic termites ?</h1>
                                    <div className='sectionText'>
                                        Un diagnostic termites est une inspection spécialisée qui vise à détecter la présence de termites dans un bâtiment. Les termites sont des insectes xylophages, capables de dégrader considérablement les structures en bois
                                        d’un immeuble, menaçant ainsi sa solidité et la sécurité de ses occupants. Le diagnostic consiste en une évaluation minutieuse effectuée par un professionnel certifié, qui inspecte le bien à la recherche de signes d’infestation
                                        actifs ou passés, tels que des galeries dans le bois, des déjections ou la présence même de termites.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticTermiteSection1Right'>
                                    <img src={diagnosticTermiteSection1} id='diagnosticTermiteSection1Image' alt='diagnostic-termite-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticTermiteSection2'>
                        <Col sm={6}>
                            <div id='diagnosticTermiteSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticTermiteSection2} className='diagnosticTermiteSection2Image' alt='diagnostic-termite-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticTermiteSection2Right'>
                                    <h1 className='sectionTitle'>Importance du diagnostic termites</h1>
                                    <div id='diagnosticTermiteSection2Accordion'>
                                        <div className='sectionAccordion'>
                                            <Accordion>
                                                {section2AccordionData.map((item, index) => {
                                                    return (
                                                        <AccordionText
                                                            key={index}
                                                            indexKey={index}
                                                            header={item.title}
                                                            body={item.text}
                                                        />
                                                    )
                                                })}
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticTermiteSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticTermiteSection3Left'>
                                    <h1 className='sectionTitle'>Quels éléments du bâti peuvent être concernés par les termites ?</h1>
                                    <div className='sectionText'>
                                        Les termites s’attaquent principalement aux éléments en bois du bâtiment, mais leur présence peut également affecter d’autres matériaux contenant de la cellulose. Voici les éléments concernés par les termites :
                                    </div>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticTermiteSection3Right'>
                                    <img src={diagnosticTermiteSection3} id='diagnosticTermiteSection3Image' alt='diagnostic-termite-section3' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticTermiteSection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticTermiteSection4Left'>
                                    <h1 className='sectionTitle'>Réalisation du diagnostic termites</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                    <img src={diagnosticTermiteSection4} id='diagnosticTermiteSection4Image' alt='diagnostic-termite-section4' />
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticTermiteSection4Right'>
                                    <h1 className='sectionTitle'>Dans quel cas peut-on se dispenser du diagnostic termites ?</h1>
                                    <div className='sectionText'>
                                        Il existe peu de cas où le diagnostic termites n’est pas requis, étant donné son importance dans la protection des biens immobiliers et de la sécurité des occupants. Cependant, voici quelques situations où le diagnostic pourrait ne pas être nécessaire :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                    <div className='sectionText'>
                                        Il est important de noter que les règles et les réglementations concernant le diagnostic des termites peuvent évoluer. Il est donc essentiel de consulter un professionnel certifié ou les autorités locales pour obtenir des conseils précis
                                        et à jour sur les obligations légales relatives au diagnostic termites pour votre bien immobilier.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticTermiteSection5'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Conséquences d'un diagnostic positif</h1>
                            <div className='sectionText'>
                                Si la présence de termites est confirmée, le propriétaire est généralement tenu de prendre des mesures pour éradiquer l’infestation et prévenir sa réapparition. Cela peut inclure des traitements chimiques ciblés ou des interventions
                                plus importantes sur la structure du bâtiment. Dans certaines régions, la déclaration d’une infestation de termites auprès des autorités locales peut être obligatoire.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticTermite'>
                    <div id='header'>
                        <div id='diagnosticTermiteHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic Termites</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticTermiteSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>En quoi consiste un diagnostic termites ?</h1>
                            <div className='sectionTextMobile'>
                                Un diagnostic termites est une inspection spécialisée qui vise à détecter la présence de termites dans un bâtiment. Les termites sont des insectes xylophages, capables de dégrader considérablement les structures en bois
                                d’un immeuble, menaçant ainsi sa solidité et la sécurité de ses occupants. Le diagnostic consiste en une évaluation minutieuse effectuée par un professionnel certifié, qui inspecte le bien à la recherche de signes d’infestation
                                actifs ou passés, tels que des galeries dans le bois, des déjections ou la présence même de termites.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticTermiteSection1} id='diagnosticTermiteSection1ImageMobile' alt='diagnostic-termite-section1' />
                        </Fade>
                    </div>
                    <div id='diagnosticTermiteSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticTermiteSection2} className='diagnosticTermiteSection2ImageMobile' alt='diagnostic-termite-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Importance du diagnostic termites</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticTermiteSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Quels éléments du bâti peuvent être concernés par les termites ?</h1>
                            <div className='sectionTextMobile'>
                                Les termites s’attaquent principalement aux éléments en bois du bâtiment, mais leur présence peut également affecter d’autres matériaux contenant de la cellulose. Voici les éléments concernés par les termites :
                            </div>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticTermiteSection3} id='diagnosticTermiteSection3ImageMobile' alt='diagnostic-termite-section3' />
                        </Fade>
                    </div>
                    <div id='diagnosticTermiteSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Réalisation du diagnostic termites</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                            <img src={diagnosticTermiteSection4} id='diagnosticTermiteSection4ImageMobile' alt='diagnostic-termite-section4' />
                        </Fade>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Dans quel cas peut-on se dispenser du diagnostic termites ?</h1>
                            <div className='sectionTextMobile'>
                                Il existe peu de cas où le diagnostic termites n’est pas requis, étant donné son importance dans la protection des biens immobiliers et de la sécurité des occupants. Cependant, voici quelques situations où le diagnostic pourrait ne pas être nécessaire :
                            </div>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                            <div className='sectionTextMobile'>
                                Il est important de noter que les règles et les réglementations concernant le diagnostic des termites peuvent évoluer. Il est donc essentiel de consulter un professionnel certifié ou les autorités locales pour obtenir des conseils précis
                                et à jour sur les obligations légales relatives au diagnostic termites pour votre bien immobilier.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticTermiteSection5Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Conséquences d'un diagnostic positif</h1>
                            <div className='sectionTextMobile'>
                                Si la présence de termites est confirmée, le propriétaire est généralement tenu de prendre des mesures pour éradiquer l’infestation et prévenir sa réapparition. Cela peut inclure des traitements chimiques ciblés ou des interventions
                                plus importantes sur la structure du bâtiment. Dans certaines régions, la déclaration d’une infestation de termites auprès des autorités locales peut être obligatoire.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default DiagnosticTermite